import { filter } from 'lodash';

import * as ActionTypes from '../components/actions/types';

const initState = [];

function stripeCardReducer(state = initState, action) {
  switch (action.type) {
    case ActionTypes.FETCH_STRIPE_CARDS:
      return action.payload;
    case ActionTypes.REMOVE_STRIPE_CARD:
      return filter(state, card => (card.id !== action.payload));
    case ActionTypes.USER_LOGOUT:
      return [];
    default: {
      return state;
    }
  }
}

export default stripeCardReducer;



// WEBPACK FOOTER //
// ./src/reducers/stripeCard.js